import { useMemo } from 'react';
import { getStoreLocation } from 'ck-utils';

export const usePhoneInputCountries = () => {
  const storeLocation = getStoreLocation();
  const countries = useMemo(() => {
    switch (storeLocation) {
      case 'US':
        return ['US', 'GB', 'CA'];
      case 'NZ':
        return ['NZ'];
      default:
        return ['AU', 'NZ', 'US', 'GB'];
    }
  }, [storeLocation]);

  return { defaultCountry: storeLocation, countries };
};
